<div [class.--is-disabled]="disabled" class="checkbox-container" (click)="toggle()" [attr.aria-label]="ariaLabel" [attr.title]="ariaLabel">
  <input type="checkbox" [indeterminate]="indeterminate" [checked]="value" [disabled]="disabled" />

  <div class="checkbox-visual" [class.--checked]="value" [class.--indeterminate]="indeterminate" [class.--disabled]="disabled">
    <div class="checker"></div>
  </div>

  @if (label) {
  <div class="checkbox-container__label">
    <label>{{ label }}</label>

    @if (sublabel) {
    <small>{{ sublabel }}</small>
    }
  </div>
  }
</div>
